import React from 'react'
import StyledH6Heading from '../../../common/components/styledH6Heading/StyledH6Heading'
import StyledMdText from '../../../common/components/styledMdText/StyledMdText'
import StyledXlText from '../../../common/components/styledXlText/StyledXlText'
import StyledSmText from '../../../common/components/styledSmText/StyledSmText'
import StyledXsText from '../../../common/components/styledXsText/StyledXsText'
import { Error } from '../../../components/toast/Error'
import Button from '../../../components/button/Button'

const ContactUsSection = () => {

    const handleToastShow = () => {
        Error({ text: "Oops!", message: "This Feature Is Coming Soon." })
    }
    return (
        <div className='py-32 text-white w-[90%] flex flex-col items-center gap-10'>
            <div className='flex flex-col items-center gap-5'>
                <div>
                    <StyledH6Heading fontColor="text-gradient">Contact Us</StyledH6Heading>
                </div>
                <div className='text-center'>
                    <StyledMdText fontColor="text-white">Any question or remarks? Just write us a message!</StyledMdText>
                </div>
            </div>
            <div className='flex flex-col w-full p-2 shadow-2xl lg:flex-row bg-opacity-20 bg-light-gray rounded-xl'>
                <div className='bg-black p-8 lg:w-[40%] rounded-xl flex flex-col gap-20 relative'>
                    <div className='absolute bottom-0 right-0'>
                        <img alt='bg' src='/assets/images/bg-contactForm.png' />
                    </div>
                    <div className='flex flex-col gap-2'>
                        <div>
                            <StyledXlText fontColor="text-gradient !font-bold">Contact Information</StyledXlText>
                        </div>
                        <div>
                            <StyledSmText fontColor="text-white">Say something to start a live chat!</StyledSmText>
                        </div>
                    </div>
                    <div className='flex flex-col gap-5'>
                        <div className='flex items-center gap-3'>
                            <div>
                                <img width={20} height={20} src='/assets/images/phone.png' alt='Phone' />
                            </div>
                            <div>
                                <StyledXsText fontColor="text-white">+92 324 9419774</StyledXsText>
                            </div>
                        </div>
                        <div className='flex items-center gap-3'>
                            <div>
                                <img width={20} height={20} src='/assets/images/location.png' alt='Phone' />
                            </div>
                            <div>
                                <StyledXsText fontColor="text-white">Lahore, Pakistan</StyledXsText>
                            </div>
                        </div>
                        <div className='flex items-center gap-3'>
                            <div>
                                <img width={20} height={20} src='/assets/images/email.png' alt='Phone' />
                            </div>
                            <div>
                                <StyledXsText fontColor="text-white">faiq.khokhar06@gmail.com</StyledXsText>
                            </div>
                        </div>
                    </div>
                    <div className='flex gap-3'>
                        <div onClick={() => handleToastShow()} className='p-1 duration-500 bg-white rounded-full cursor-pointer hover:-translate-y-1'>
                            <img width={20} height={20} src='/assets/images/instagram.png' alt='Instagram' />
                        </div>
                        <div onClick={() => handleToastShow()} className='p-1 duration-500 bg-white rounded-full cursor-pointer hover:-translate-y-1'>
                            <img width={20} height={20} src='/assets/images/discord.png' alt='Discord' />
                        </div>
                    </div>
                </div>
                <div className='lg:w-[60%] py-10 flex justify-center items-center'>
                    <div className='w-[90%] lg:w-[80%] flex flex-col gap-10'>
                        <div className='grid grid-cols-1 gap-10 md:grid-cols-2'>
                            <div className='flex flex-col gap-2'>
                                <div>
                                    <StyledXsText>First Name</StyledXsText>
                                </div>
                                <div>
                                    <input placeholder='Enter Your First Name' className='w-full pb-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none' type='text' />
                                </div>
                            </div>
                            <div className='flex flex-col gap-2'>
                                <div>
                                    <StyledXsText>Last Name</StyledXsText>
                                </div>
                                <div>
                                    <input placeholder='Enter Your Last Name' className='w-full pb-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none' type='text' />
                                </div>
                            </div>
                            <div className='flex flex-col gap-2'>
                                <div>
                                    <StyledXsText>Email</StyledXsText>
                                </div>
                                <div>
                                    <input placeholder='Enter Your Email' className='w-full pb-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none' type='text' />
                                </div>
                            </div>
                            <div className='flex flex-col gap-2'>
                                <div>
                                    <StyledXsText>Contact Number</StyledXsText>
                                </div>
                                <div>
                                    <input placeholder='Enter Your Contact Number' className='w-full pb-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none' type='text' />
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-col gap-2'>
                            <div>
                                <StyledXsText>Message</StyledXsText>
                            </div>
                            <div>
                                <textarea placeholder='Write Your Message...' className='w-full bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none' type='text' />
                            </div>
                        </div>
                        <div className='flex self-end justify-end w-full md:w-[40%]'>
                            <Button onClick={() => handleToastShow()} variant="button-gradient" fontColor="flex items-center gap-3 justify-center text-md text-black">Submit</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactUsSection
